import { Fragment } from "react";
import clsx from "clsx";
import PricingFeatureCard from "components/organism/Cards/PricingFeatureCard";
import { featureList } from "data";

const DesktopFeatures = () => {
    return (
        <Fragment>
            {/* Tablet \ Desktop Device */}
            <section className={clsx(
                "pt-16 tablet:pt-[67px] phone:pt-10 px-6 tablet:px-8 desktop:px-[120px]"
            )}>
                <div className="hidden md:grid grid-cols-1 md:grid-cols-3 tablet:gap-x-6 tablet:gap-y-8 desktop:gap-x-8 desktop:gap-y-10 gap-8">
                    {featureList.slice(0, 3).map((item) => (
                        <PricingFeatureCard key={item.id} icons={item.icons} title={item.title} description={item.description} />))}
                </div>
                <div className="hidden md:grid grid-cols-1 md:grid-cols-3 tablet:gap-x-6 tablet:gap-y-8 desktop:gap-x-8 desktop:gap-y-12 gap-8 tablet:mt-[32px] desktop:mt-[40px]">
                    {featureList.slice(3, 12).map((item) => (
                        <PricingFeatureCard key={item.id} icons={item.icons} title={item.title} description={item.description} />))}
                </div>
            </section>
        </Fragment>
    );
};

export default DesktopFeatures;